<template>
  <modal
    name="faqEdit"
    height="auto"
    width="900"
    :scrollable="true"
    :clickToClose="false"
    @before-open="prepararFormulario"
  >
    <CloseModal :close="close" />
    <Loading :isActive="loading" />
    <div class="modalbox">
      <div class="modalbox-content">
        <CTabs variant="tabs" class="nav-tabs-boxed">
          <CTab :title="tituloModal">
            <StepArtigo
              :item="item"
              :tipos="tipos"
              :validacao="validation"
            />
            <StepDisponibilidade :item="item" :validacao="validation" />
            <StepConteudo :item="item" :validacao="validation" />
          </CTab>
        </CTabs>
      </div>
    </div>
    <div class="modal-footer-bar">
      <CButton variant="outline" color="secondary" @click="close">
        Cancelar
      </CButton>
      <CButton color="primary" @click="handleSubmit">
        {{ item.id ? "Salvar Alterações" : "Criar Artigo" }}
      </CButton>
    </div>
  </modal>
</template>

<script>
import SimpleVueValidation from "simple-vue-validator";
import { post, put } from "@/helpers/apiRequest";
import CloseModal from "@/components/CloseModal";
import Loading from "@/components/Loading.vue";
import StepArtigo from "../sections/StepArtigo.vue";
import StepDisponibilidade from "../sections/StepDisponibilidade.vue";
import StepConteudo from "../sections/StepConteudo.vue";
import { normalizeFaqParaApi } from "../helpers/faqDefaults";

const Validator = SimpleVueValidation.Validator.create({
  templates: {
    required: "*obrigatório",
  },
});

export default {
  name: "FaqFormPage",
  components: {
    CloseModal,
    Loading,
    StepArtigo,
    StepDisponibilidade,
    StepConteudo,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    tipos: {
      type: Array,
      default: () => [],
    },
    close: {
      type: Function,
      required: true,
    },
    descSingular: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    tituloModal() {
      return `${this.item.id ? "Editando" : "Criando"} ${this.descSingular}`;
    },
  },
  validators: {
    "item.titulo": (value) => Validator.value(value).required(),
    "item.tipo": (value) => Validator.value(value).required(),
    "item.palavras_chave": (value) => Validator.value(value).required(),
    "item.conteudo": (value) => Validator.value(value).required(),
    /**
     * O erro fica publicado no primeiro campo da lista, que é onde a seção de
     * disponibilidade lê a mensagem.
     */
    "item.acessab2b, item.acessacallcenter, item.acessafv, item.acessachat, item.acessasac":
      function (b2b, callcenter, fv, chat, sac) {
        return Validator.custom(() => {
          if ([b2b, callcenter, fv, chat, sac].some(Boolean)) {
            return;
          }

          return "Marque ao menos um sistema";
        });
      },
  },
  methods: {
    prepararFormulario() {
      this.validation.reset();
    },
    handleSubmit() {
      this.$validate().then((success) => {
        if (!success) {
          return;
        }

        const normalizado = normalizeFaqParaApi(this.item);

        if (this.item.id) {
          this.atualizar(normalizado);
          return;
        }

        this.criar(normalizado);
      });
    },
    criar(item) {
      this.enviar(post("/admin/faq", item));
    },
    atualizar(item) {
      this.enviar(put(`/admin/faq/${item.id}`, item));
    },
    enviar(request) {
      this.loading = true;

      request
        .then((json) => {
          this.close();
          this.$swal({
            title: "Salvo com sucesso",
            text: json.message,
            showCancelButton: false,
            showConfirmButton: true,
            icon: "success",
          });
        })
        .catch((error) => {
          this.$swal({
            title: "Falha ao Salvar",
            text: error.message,
            showCancelButton: true,
            cancelButtonText: "Fechar",
            showConfirmButton: false,
            icon: "error",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.modal-footer-bar {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  padding: 14px 20px;
  border-top: 1px solid #e9ecef;
  background: #fff;
}
</style>

<style>
/* Compactar formulário dentro do modal do FAQ */
.modalbox .tab-pane {
  padding: 14px 16px !important;
}

.modalbox .form-group {
  margin-bottom: 10px;
}
</style>
